import MainLayout from 'layouts/MainLayout';

import Start from '../pages/Start';
import Conversation from '../pages/Conversation';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/rossato-orari-ocr/:agentId',
        element: Start,
        exact: true,
        analytics: { name: ["Agente", "Rossato orari"] },
    }, {
        path: '/agents/rossato-orari-ocr/:agentId/conversations/:conversationId',
        element: Conversation,
        exact: true,
        analytics: { name: ["Agente", "Conversazione"] },
    }]
}]

export default routes;